export const StringsES = {
    // Buttons
    buttons: {
        button_back: 'Volver',
        button_loginGoogle: 'Entrar con Google',
        button_loginMicrosoft: 'Entrar con Microsoft',
        button_accept: 'Aceptar',
        button_cancel: 'Cancelar',
        button_logout: 'Salir',
        button_settings: 'Configuración',
        button_save: 'Guardar',
        button_exit: 'Salir',
        button_edit: 'Editar',
        button_openDicom: 'Abrir DICOM',
        button_classify: 'Classificar',
        button_data: 'Datos',
        button_modify: 'Modificar',
        button_results: 'Resultados',
    },
    // Errors
    errors: {
        // Login errros 
        loginErrorUnknownUser: 'Usuario sin acceso a la plataforma',
        loginErrorUnknown: 'Error desconocido',
        // Format (generic validators)
        error_maxValue: 'Valor demasiado grande',
        error_minValue: 'Valor demasiado pequeño',
        error_step: 'Resolución demasiado elevada',
        error_required: 'Campo obligatorio',
        error_maxLength: 'Demasiados caracteres',
        error_specialCharacters: 'Caracteres no permitidos',
        error_spacesInString: 'No puede contener espacios',
        error_dicomNotInCm: 'Este archivo DICOM no se puede procesar. Las unidades físicas de la imagen no están en centímetros',
    },
    // General app strings
    appStrings: {
        waitingMessageLoadDicom: 'Cargando DICOM. Por favor, espere...',
        waitingMessageClassifyDicom: 'Segmentando imagen DICOM. Por favor, espere...',
        waitingMessageModifyingData: 'Actualizando segmentación. Por favor, espere...',
        waitingMessageGeneratingResults: 'Generando resultados. Por favor, espere...',
        imagePlaceholder: 'Área de visualización de la imagen DICOM',
    },
    // Additional data popup
    additionalDataPopupStrings: {
        title: 'Datos del paciente',
        inputBoxLabelPatientAge: 'Edad (años)',
        inputBoxLabelPatientWeight: 'Peso (kg)',
        inputBoxLabelPatientHeight: 'Altura (m)',
        radioButtonTitlePatientSex: 'Sexo:',
        radioButtonLabelsPatientSex: ['Hombre', 'Mujer', 'Otro'],
    },
    // User feedback strings
    feedbackStrings:{
        successfullySaved: 'Guardado correctamente',
        noRemainingAnalysis: 'No tiene análisis disponible. Contacte con soporte',
        licenseExpired: 'Su licencia ha caducado. Contacte con soporte',
    },
    // Popups
    popups: {
        titleSaveChanges: 'Cambios sin guardar',
        textSaveChanges: '¿Desea guardarlos?',
        inputBoxLabelPatientId: 'ID del paciente',
        inputBoxLabelStudyId: 'ID del estudio',
        titleSetPatientId: 'Los archivos DICOM han sido anonimizados. Por favor, especifique nuevos identificadores para los resultados:',
    },
}